import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next"; // For i18n
import { Home, FilePlus, FileText, Layout, Settings, LogOut, ChevronLeft, ChevronRight, Table } from "lucide-react";
import "../styles/Sidebar.css";

const Sidebar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    { path: "/dashboard", label: t("sidebar.dashboard"), icon: <Home size={20} /> },
    { path: "/create-certificate", label: t("sidebar.createCertificate"), icon: <FilePlus size={20} /> },
    { path: "/manage-certificates", label: t("sidebar.manageCertificates"), icon: <FileText size={20} /> },
    { path: "/templates", label: t("sidebar.templates"), icon: <Layout size={20} /> },
    { path: "/training-matrix", label: t("sidebar.trainingMatrix"), icon: <Table size={20} />, beta: true },
    { path: "/settings", label: t("sidebar.settings"), icon: <Settings size={20} /> },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        <div className="logo-section">
          <img src="/auraplan_academy_icon2.png" alt="Auraplan Logo" className="logo-image" />
          {!isCollapsed && (
            <div className="logo-text">
              <span className="company-name">{t("sidebar.logo")}</span>
            </div>
          )}
        </div>
        <button className="collapse-btn" onClick={() => setIsCollapsed(!isCollapsed)}>
          {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <button
            key={item.path}
            className={`sidebar-item ${location.pathname === item.path ? "active" : ""}`}
            onClick={() => navigate(item.path)}
            title={isCollapsed ? item.label : ""}
          >
            <span className="sidebar-icon">{item.icon}</span>
            {!isCollapsed && (
              <span className="sidebar-label">
                {item.label}
                {item.beta && <span className="sidebar-beta-badge">BETA</span>}
              </span>
            )}
          </button>
        ))}
      </nav>
      <div className="sidebar-footer">
        <button className="sidebar-item logout-btn" onClick={handleLogout} title={isCollapsed ? t("sidebar.logout") : ""}>
          <span className="sidebar-icon"><LogOut size={20} /></span>
          {!isCollapsed && <span className="sidebar-label">{t("sidebar.logout")}</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;